import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import UseTranslation from '../../../../../hooks/UseTranslation'
import { getNotificationsCenterBell, notificationCenterResetAlertHandler }
  from '../../../../../redux/features/notifications/notificationCenter/notificationCenterThunk'
import NoDataFound from '../../../../PageHelpers/NoDataFound'
import NotificationsCard from '../NotificationsCard';
import LoaderWithErrorHandler from '../../../../PageHelpers/LoaderWithErrorHandler';
import { selectNotification } from '../../../../../redux/features/notifications/notificationCenter/notificationCenterSlice';
import CenterBellSkeleton from './CenterBellSkeleton'

const CenterBellCard = () => {
  const notificationCenterStore = useSelector(selectNotification)
  const { t } = UseTranslation()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getNotificationsCenterBell())
  }, [])

  const renderNoDataFound = (store) => {
    if (store.loading.fetch !== true &&
      Object.values(store?.notificationsBell).every((arr) => !arr?.length)) {
      return <NoDataFound customStyle={styles.noDataFound} />
    }
    return null
  }
  const closePopupAndNavigate = (event, url) => {
    event.preventDefault();
    window.location.href = url
  }
  return (
    <Box>
      <Box
        component="a"
        href="/notifications/center"
        rel="noopener noreferrer"
        onClick={(event) => closePopupAndNavigate(event, '/notifications/center')}
        style={styles.showAllLink}
      >
        <Typography sx={styles.showAllText}>
          {t?.['Show all']}
        </Typography>
      </Box>
      <Box sx={styles.notificationCardList} data-testid="notification_Center_Container">
        {['today', 'yesterday', 'earlier'].map((timeFrame) => (
          notificationCenterStore?.notificationsBell?.[timeFrame]?.length > 0 && (
            <Box key={timeFrame}>
              <Typography sx={styles.notificationTitle}>
                {t?.[timeFrame]}
              </Typography>
              {notificationCenterStore?.notificationsBell?.[timeFrame]?.map(
                (singleNotification, index) => (
                <NotificationsCard
                  key={singleNotification?.id}
                  notification={singleNotification}
                  icon={<NotificationsNoneOutlinedIcon />}
                  title={timeFrame}
                  customAnimation={index}
                />
                ),
              )}
            </Box>
          )
        ))}
      </Box>
      <LoaderWithErrorHandler
        store={notificationCenterStore}
        resetAlertHandler={notificationCenterResetAlertHandler}
        Skeleton={CenterBellSkeleton} />
      {renderNoDataFound(notificationCenterStore)}

    </Box>
  )
}
const styles = {
  notificationTitle: {
    color: 'text.disabled',
    fontFamily: 'Avenir',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
  },
  showAllLink: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'end',
    margin: '10px 0px 0px',
  },
  showAllText: {
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: '500',
    cursor: 'pointer',
    color: '#29cc8b !important',
  },
  notificationCardList: {
    maxHeight: { xs: '400px', sm: '390px' },
    overflowY: 'scroll',
    '::-webkit-scrollbar': {
      width: '0.1em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
    },
  },
  noDataFound: {
    paddingTop: { xs: '30px', sm: '50px' },
    '& img': {
      width: { xs: '200px', sm: '350px' },
      height: { xs: '220px', sm: '310px' },
    },
  },
}
export default CenterBellCard
